import React, { useState, useEffect, useContext, useCallback } from "react";
import "./EmployeeForm.css";
import { Usercontext } from "../../App";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utills/axiosInstance";

const EmployeeForm = () => {
  const { title, setTitle } = useContext(Usercontext);
  const [managers, setManagers] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [showMarriageDate, setShowMarriageDate] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    empId: "",
    middleName: "",
    email: "",
    blood: "",
    department: "",
    location: "",
    designation: "",
    employmentType: "",
    employeeStatus: "",
    sourceOfHire: "",
    dateOfJoining: "",
    currentExperience: "",
    totalExperience: "",
    primaryReportingManager: "",
    secondaryReportingManager: "",
    dateOfBirth: "",
    age: "",
    gender: "",
    maritalStatus: "",
    aboutMe: "",
    UAN: "",
    PAN: "",
    Aadhaar: "",
    phoneNumber: "",
    extension: "",
    seatingLocation: "",
    personalEmailAddress: "",
    presentAddress: "",
    dateOfExit: "",
    marriageDate: "",
    employeeRole: "",
    educations: [{}],
    experiences: [{}],
    dependents: [{}],
    file: null
  });

  const [editMode, setEditMode] = useState(false);
  const [currentImageId, setCurrentImageId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [deptRes, desigRes] = await Promise.all([
          axiosInstance.get('/api/departments'),
          axiosInstance.get('/api/designations')
        ]);
        setDepartments(deptRes.data || []);
        setDesignations(desigRes.data || []);
      } catch (error) {
        console.error("There was an error fetching departments/designations:", error);
      }
    };

    fetchData();

    const fetchManagers = async () => {
      try {
        const response = await axiosInstance.get('/api/repomanager');
        const data = response.data;
        if (Array.isArray(data)) {
          setManagers(data);
        }
      } catch (error) {
        console.error("Error fetching managers:", error);
      }
    };

    fetchManagers();
  }, []);

  useEffect(() => {
    if (title && title._id) {
      const flattenedData = {
        firstName: title.firstName || "",
        lastName: title.lastName || "",
        empId: title.empId || "",
        middleName: title.middleName || "",
        email: title.email || "",
        blood: title.blood || "",
        department: title.department || "",
        location: title.location || "",
        designation: title.designation || "",
        employmentType: title.employmentType || "",
        employeeStatus: title.employeeStatus || "",
        sourceOfHire: title.sourceOfHire || "",
        dateOfJoining: title.dateOfJoining ? new Date(title.dateOfJoining).toISOString().split("T")[0] : "",
        currentExperience: title.currentExperience || "",
        totalExperience: title.totalExperience || "",
        primaryReportingManager: title.primaryReportingManager?._id || title.primaryReportingManager || "",
        secondaryReportingManager: title.secondaryReportingManager?._id || title.secondaryReportingManager || "",
        dateOfBirth: title.dateOfBirth ? new Date(title.dateOfBirth).toISOString().split("T")[0] : "",
        age: title.age || "",
        gender: title.gender || "",
        maritalStatus: title.maritalStatus || "",
        aboutMe: title.aboutMe || "",
        UAN: title.UAN || "",
        PAN: title.PAN || "",
        Aadhaar: title.Aadhaar || "",
        phoneNumber: title.phoneNumber || "",
        extension: title.extension || "",
        seatingLocation: title.seatingLocation || "",
        personalEmailAddress: title.personalEmailAddress || "",
        presentAddress: title.presentAddress || "",
        dateOfExit: title.dateOfExit ? new Date(title.dateOfExit).toISOString().split("T")[0] : "",
        marriageDate: title.marriageDate ? new Date(title.marriageDate).toISOString().split("T")[0] : "",
        employeeRole: title.employeeRole || "",
        educations: title.educations || [{}],
        experiences: title.experiences || [{}],
        dependents: title.dependent || [{}],
        file: null
      };

      setFormData(flattenedData);
      setShowMarriageDate(title.maritalStatus === "Married");
      setPreviewUrl(title.image || "");
      setEditMode(true);
      setCurrentImageId(title._id);
    } else {
      setEditMode(false);
      setShowMarriageDate(false);
      setPreviewUrl(null);
    }
  }, [title]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "maritalStatus" && value === "Married") {
      setShowMarriageDate(true);
    } else if (name === "maritalStatus" && value === "Single") {
      setShowMarriageDate(false);
    }

    if (name === "dateOfBirth") {
      const dob = new Date(value);
      const currentDate = new Date();
      let age = currentDate.getFullYear() - dob.getFullYear();
      const month = currentDate.getMonth() - dob.getMonth();

      if (month < 0 || (month === 0 && currentDate.getDate() < dob.getDate())) {
        age -= 1;
      }

      if (age < 18) {
        alert("You must be at least 18 years old.");
        setFormData((prevData) => ({
          ...prevData,
          dateOfBirth: "",
          age: "",
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          dateOfBirth: value,
          age: age,
        }));
      }
    }
  };

  const handleEducationChange = useCallback((index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      educations: prev.educations.map((edu, i) =>
        i === index ? { ...edu, [field]: value } : edu
      ),
    }));
  }, []);

  const handleExperienceChange = useCallback((index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      experiences: prev.experiences.map((exp, i) =>
        i === index ? { ...exp, [field]: value } : exp
      ),
    }));
  }, []);

  const handleDependentChange = useCallback((index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      dependents: prev.dependents.map((dep, i) =>
        i === index ? { ...dep, [field]: value } : dep
      ),
    }));
  }, []);

  const handleAddEducation = () => {
    setFormData((prev) => ({
      ...prev,
      educations: [...prev.educations, {}],
    }));
  };

  const handleRemoveEducation = (index) => {
    setFormData((prev) => ({
      ...prev,
      educations: prev.educations.length > 1 ? prev.educations.filter((_, i) => i !== index) : prev.educations,
    }));
  };

  const handleAddExperience = () => {
    setFormData((prev) => ({
      ...prev,
      experiences: [...prev.experiences, {}],
    }));
  };

  const handleRemoveExperience = (index) => {
    setFormData((prev) => ({
      ...prev,
      experiences: prev.experiences.length > 1 ? prev.experiences.filter((_, i) => i !== index) : prev.experiences,
    }));
  };

  const handleAddDependent = () => {
    setFormData((prev) => ({
      ...prev,
      dependents: [...prev.dependents, {}],
    }));
  };

  const handleRemoveDependent = (index) => {
    setFormData((prev) => ({
      ...prev,
      dependents: prev.dependents.length > 1 ? prev.dependents.filter((_, i) => i !== index) : prev.dependents,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        file: file,
      }));
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      setFormData((prev) => ({ ...prev, file: null }));
      setPreviewUrl(null);
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    const data = new FormData();

    if (!formData.firstName || formData.firstName.length < 3) {
      alert("First Name must be at least 3 characters long.");
      return;
    }
    if (!formData.dateOfJoining) {
      alert("Date of Joining is required.");
      return;
    }

    if (!formData.dateOfBirth) {
      alert("Date of Birth is required.");
      return;
    }

    if (!formData.personalEmailAddress) {
      alert("Personal Email is required.");
      return;
    }

    if (!formData.lastName || formData.lastName.length < 3) {
      alert("Last Name must be at least 3 characters long.");
      return;
    }

    if (!formData.empId) {
      alert("Employee ID must be a valid number greater than zero.");
      return;
    }

    if (!formData.file && !editMode) {
      alert("Please select an image file.");
      return;
    }

    if (formData.phoneNumber && !/^[0-9]{10}$/.test(formData.phoneNumber)) {
      alert("Invalid phone number format. It must be 10 digits.");
      return;
    }

    data.append("firstName", formData.firstName);
    data.append("lastName", formData.lastName);
    data.append("empId", formData.empId);
    data.append("middleName", formData.middleName);
    data.append("email", formData.email);
    data.append("blood", formData.blood);
    data.append("department", formData.department);
    data.append("location", formData.location);
    data.append("designation", formData.designation);
    data.append("employmentType", formData.employmentType);
    data.append("employeeStatus", formData.employeeStatus);
    data.append("sourceOfHire", formData.sourceOfHire);
    data.append("dateOfJoining", formData.dateOfJoining);
    data.append("currentExperience", formData.currentExperience);
    data.append("totalExperience", formData.totalExperience);
    data.append("primaryReportingManager", formData.primaryReportingManager);
    data.append("secondaryReportingManager", formData.secondaryReportingManager);
    data.append("dateOfBirth", formData.dateOfBirth);
    data.append("age", formData.age);
    data.append("gender", formData.gender);
    data.append("maritalStatus", formData.maritalStatus);
    data.append("aboutMe", formData.aboutMe);
    data.append("UAN", formData.UAN);
    data.append("PAN", formData.PAN);
    data.append("Aadhaar", formData.Aadhaar);
    data.append("phoneNumber", formData.phoneNumber);
    data.append("extension", formData.extension);
    data.append("seatingLocation", formData.seatingLocation);
    data.append("personalEmailAddress", formData.personalEmailAddress);
    data.append("presentAddress", formData.presentAddress);
    data.append("dateOfExit", formData.dateOfExit);
    data.append("marriageDate", formData.marriageDate);
    data.append("employeeRole", formData.employeeRole);
    data.append("educations", JSON.stringify(formData.educations));
    data.append("experiences", JSON.stringify(formData.experiences));
    data.append("dependents", JSON.stringify(formData.dependents));

    if (formData.file) {
      data.append("image", formData.file);
    }

    try {
      if (editMode && currentImageId) {
        await axiosInstance.put(`/api/images/${currentImageId}`, data);
      } else {
        await axiosInstance.post('/api/upload', data);
      }

      // const resetData = {
      //   firstName: "",
      //   lastName: "",
      //   empId: "",
      //   middleName: "",
      //   email: "",
      //   blood: "",
      //   department: "",
      //   location: "",
      //   designation: "",
      //   employmentType: "",
      //   employeeStatus: "",
      //   sourceOfHire: "",
      //   dateOfJoining: "",
      //   currentExperience: "",
      //   totalExperience: "",
      //   primaryReportingManager: "",
      //   secondaryReportingManager: "",
      //   dateOfBirth: "",
      //   age: "",
      //   gender: "",
      //   maritalStatus: "",
      //   aboutMe: "",
      //   UAN: "",
      //   PAN: "",
      //   Aadhaar: "",
      //   phoneNumber: "",
      //   extension: "",
      //   seatingLocation: "",
      //   personalEmailAddress: "",
      //   presentAddress: "",
      //   dateOfExit: "",
      //   marriageDate: "",
      //   employeeRole: "",
      //   educations: [{}],
      //   experiences: [{}],
      //   dependents: [{}],
      //   file: null
      // };
      // setFormData(resetData);
      // setPreviewUrl(null);
      // setTitle({ firstName: "", lastName: "", empId: "" });
      // setShowMarriageDate(false);

      // navigate("/employeedata");
    } catch (error) {
      if (error.response?.data?.error === "Invalid PAN format") {
        alert("Invalid PAN format");
      }
      alert("Error uploading image. Please try again.");
    }
  };

  const handleCancel = () => {
    const resetData = {
      firstName: "",
      lastName: "",
      empId: "",
      middleName: "",
      email: "",
      blood: "",
      department: "",
      location: "",
      designation: "",
      employmentType: "",
      employeeStatus: "",
      sourceOfHire: "",
      dateOfJoining: "",
      currentExperience: "",
      totalExperience: "",
      primaryReportingManager: "",
      secondaryReportingManager: "",
      dateOfBirth: "",
      age: "",
      gender: "",
      maritalStatus: "",
      aboutMe: "",
      UAN: "",
      PAN: "",
      Aadhaar: "",
      phoneNumber: "",
      extension: "",
      seatingLocation: "",
      personalEmailAddress: "",
      presentAddress: "",
      dateOfExit: "",
      marriageDate: "",
      employeeRole: "",
      educations: [{}],
      experiences: [{}],
      dependents: [{}],
      file: null
    };
    setFormData(resetData);
    setShowMarriageDate(false);
    setPreviewUrl(null);
    setTitle({ firstName: "", lastName: "", empId: "" });
    navigate("/employeedata");
  };

  const getDesignations = (deptName) => {
    if (!deptName) return [];
    return designations.filter(desig => desig.department && desig.department.name === deptName);
  };

  return (
    <>
      <div className="app-container">
        <div className="header-section">
          <h2 className="page-title">Employee Details</h2>
        </div>
        <form className="upload-form" onSubmit={handleUpload}>
          <div className="action-buttons">
            <button type="submit" className="btn btn-primary">
              {editMode ? "Update Employee" : "Save Employee"}
            </button>
            <button type="button" className="btn btn-secondary" onClick={handleCancel}>
              Cancel
            </button>
          </div>

          <div className="form-container">
            {/* Employee Basic Info Section */}
            <section className="form-section">
              <h3 className="section-title">Basic Information</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="file" className="form-label">
                    Upload Profile Picture <span className="required">*</span>
                  </label>
                  <input
                    type="file"
                    id="file"
                    name="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="form-control"
                    required={!editMode}
                  />
                  {previewUrl && (
                    <img src={previewUrl} alt="Profile Picture" className="image-preview" />
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="empId" className="form-label">
                    Employee ID <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="empId"
                    name="empId"
                    maxLength={10}
                    value={formData.empId}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="firstName" className="form-label">
                    First Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    placeholder="Enter First Name"
                    pattern="[A-Za-z\s]+"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="middleName" className="form-label">Middle Name</label>
                  <input
                    type="text"
                    id="middleName"
                    name="middleName"
                    pattern="[A-Za-z\s]+"
                    value={formData.middleName}
                    onChange={handleInputChange}
                    placeholder="Enter Middle Name"
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName" className="form-label">
                    Last Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    placeholder="Enter Last Name"
                    pattern="[A-Za-z\s]+"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Email <span className="required">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter Email"
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="blood" className="form-label">
                    Blood Group <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="blood"
                    name="blood"
                    value={formData.blood}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="location" className="form-label">Location</label>
                  <input
                    type="text"
                    id="location"
                    name="location"
                    pattern="[A-Za-z\s]+"
                    value={formData.location}
                    onChange={handleInputChange}
                    placeholder="Enter Location"
                    className="form-control"
                  />
                </div>
              </div>
            </section>

            {/* Employment Details Section */}
            <section className="form-section">
              <h3 className="section-title">Employment Details</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="department" className="form-label">Department</label>
                  <select
                    id="department"
                    name="department"
                    value={formData.department}
                    onChange={handleInputChange}
                    className="form-control"
                  >
                    <option value="">Select Department</option>
                    {departments?.map((department) => (
                      <option key={department._id} value={department.name}>
                        {department.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="designation" className="form-label">Designation</label>
                  <select
                    id="designation"
                    name="designation"
                    value={formData.designation}
                    onChange={handleInputChange}
                    className="form-control"
                    disabled={!formData.department}
                  >
                    <option value="">Select Designation</option>
                    {getDesignations(formData.department).map((designation) => (
                      <option key={designation._id} value={designation.name}>
                        {designation.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="employmentType" className="form-label">
                    Employment Type <span className="required">*</span>
                  </label>
                  <select
                    id="employmentType"
                    name="employmentType"
                    value={formData.employmentType}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  >
                    <option value="">Select Employment Type</option>
                    <option value="Full-time">Full-time</option>
                    <option value="Part-time">Part-time</option>
                    <option value="Trainee">Trainee</option>
                    <option value="Interns">Interns</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="employeeStatus" className="form-label">
                    Employee Status <span className="required">*</span>
                  </label>
                  <select
                    id="employeeStatus"
                    name="employeeStatus"
                    value={formData.employeeStatus}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  >
                    <option value="">Select Employee Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Terminated">Terminated</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="sourceOfHire" className="form-label">Source of Hire</label>
                  <select
                    id="sourceOfHire"
                    name="sourceOfHire"
                    value={formData.sourceOfHire}
                    onChange={handleInputChange}
                    className="form-control"
                  >
                    <option value="">Select Source of Hire</option>
                    <option value="Walk-in Drive">Walk-in Drive</option>
                    <option value="Employee Referrals">
                      Employee Referrals
                    </option>
                    <option value="Past Employees">Past Employees</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="dateOfJoining" className="form-label">
                    Date of Joining <span className="required">*</span>
                  </label>
                  <input
                    type="date"
                    id="dateOfJoining"
                    name="dateOfJoining"
                    value={
                      formData.dateOfJoining
                        ? new Date(formData.dateOfJoining)
                          .toISOString()
                          .split("T")[0]
                        : ""
                    }
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="employeeRole" className="form-label">Employee Role</label>
                  <select
                    id="employeeRole"
                    name="employeeRole"
                    value={formData.employeeRole}
                    onChange={handleInputChange}
                    className="form-control"
                  >
                    <option value="">Select Employee Role</option>
                    <option value="Employee">Employee</option>
                    <option value="Reporting Manager">Reporting Manager</option>
                    <option value="Admin">Admin</option>
                  </select>
                </div>
              </div>
            </section>

            {/* Hierarchy Section */}
            <section className="form-section">
              <h3 className="section-title">Hierarchy Information</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="primaryReportingManager" className="form-label">
                    Primary Reporting Manager <span className="required">*</span>
                  </label>
                  <select
                    id="primaryReportingManager"
                    name="primaryReportingManager"
                    value={formData.primaryReportingManager}
                    onChange={handleInputChange}
                    className="form-control"
                  >
                    <option value="">Select Primary Reporting Manager</option>
                    {managers.length > 0 ? (
                      managers.map((manager, index) => (
                        <option key={index} value={manager.id}>
                          {manager.name}
                        </option>
                      ))
                    ) : (
                      <option value="">No Managers Available</option>
                    )}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="secondaryReportingManager" className="form-label">
                    Secondary Reporting Manager
                  </label>
                  <select
                    id="secondaryReportingManager"
                    name="secondaryReportingManager"
                    value={formData.secondaryReportingManager}
                    onChange={handleInputChange}
                    className="form-control"
                  >
                    <option value="">Select Secondary Reporting Manager</option>
                    {managers.length > 0 ? (
                      managers.map((manager, index) => (
                        <option key={index} value={manager.id}>
                          {manager.name}
                        </option>
                      ))
                    ) : (
                      <option value="">No Managers Available</option>
                    )}
                  </select>
                </div>
              </div>
            </section>

            {/* Personal Information Section */}
            <section className="form-section">
              <h3 className="section-title">Personal Information</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="dateOfBirth" className="form-label">
                    Date of Birth <span className="required">*</span>
                  </label>
                  <input
                    type="date"
                    id="dateOfBirth"
                    name="dateOfBirth"
                    value={
                      formData.dateOfBirth
                        ? new Date(formData.dateOfBirth)
                          .toISOString()
                          .split("T")[0]
                        : ""
                    }
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="age" className="form-label">Age</label>
                  <input
                    type="text"
                    id="age"
                    name="age"
                    value={formData.age || ""}
                    className="form-control"
                    disabled
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="gender" className="form-label">
                    Gender <span className="required">*</span>
                  </label>
                  <select
                    id="gender"
                    name="gender"
                    value={formData.gender}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Transgender">Transgender</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="maritalStatus" className="form-label">
                    Marital Status <span className="required">*</span>
                  </label>
                  <select
                    id="maritalStatus"
                    name="maritalStatus"
                    value={formData.maritalStatus}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  >
                    <option value="">Select Marital Status</option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                  </select>
                </div>
                {showMarriageDate && (
                  <div className="form-group">
                    <label htmlFor="marriageDate" className="form-label">Marriage Date</label>
                    <input
                      type="date"
                      id="marriageDate"
                      name="marriageDate"
                      value={formData.marriageDate ? new Date(formData.marriageDate).toISOString().split("T")[0] : ""}
                      onChange={handleInputChange}
                      className="form-control"
                    />
                  </div>
                )}
                <div className="form-group full-width">
                  <label htmlFor="aboutMe" className="form-label">About Me</label>
                  <textarea
                    id="aboutMe"
                    name="aboutMe"
                    value={formData.aboutMe}
                    onChange={handleInputChange}
                    rows={3}
                    className="form-control"
                  />
                </div>
              </div>
            </section>

            {/* Identity Information Section */}
            <section className="form-section">
              <h3 className="section-title">Identity Information</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="UAN" className="form-label">UAN</label>
                  <input
                    type="password"
                    id="UAN"
                    name="UAN"
                    pattern="\d{12}"
                    maxLength="12"
                    className="form-control"
                    value={formData.UAN}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="PAN" className="form-label">PAN</label>
                  <input
                    type="password"
                    id="PAN"
                    name="PAN"
                    maxLength="10"
                    className="form-control"
                    value={formData.PAN}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="Aadhaar" className="form-label">Aadhaar</label>
                  <input
                    type="password"
                    id="Aadhaar"
                    name="Aadhaar"
                    pattern="\d{12}"
                    maxLength="12"
                    className="form-control"
                    value={formData.Aadhaar}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="phoneNumber" className="form-label">
                    Phone Number <span className="required">*</span>
                  </label>
                  <input
                    type="tel"
                    id="phoneNumber"
                    name="phoneNumber"
                    pattern="\d{10}"
                    maxLength="10"
                    className="form-control"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="extension" className="form-label">Extension</label>
                  <input
                    type="text"
                    id="extension"
                    name="extension"
                    className="form-control"
                    value={formData.extension}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="seatingLocation" className="form-label">Seating Location</label>
                  <input
                    type="number"
                    id="seatingLocation"
                    name="seatingLocation"
                    className="form-control"
                    value={formData.seatingLocation}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="personalEmailAddress" className="form-label">
                    Personal Email Address <span className="required">*</span>
                  </label>
                  <input
                    type="email"
                    id="personalEmailAddress"
                    name="personalEmailAddress"
                    className="form-control"
                    value={formData.personalEmailAddress}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group full-width">
                  <label htmlFor="presentAddress" className="form-label">Present Address</label>
                  <textarea
                    id="presentAddress"
                    name="presentAddress"
                    rows="3"
                    className="form-control"
                    value={formData.presentAddress}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="dateOfExit" className="form-label">Date of Exit</label>
                  <input
                    type="date"
                    id="dateOfExit"
                    name="dateOfExit"
                    value={formData.dateOfExit ? new Date(formData.dateOfExit).toISOString().split("T")[0] : ""}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
            </section>

            {/* Work Experience Section */}
            <section className="form-section">
              <h3 className="section-title">Work Experience</h3>
              <div className="form-grid">
                {formData.experiences.map((exp, index) => (
                  <div key={index} className="experience-block">
                    <h4 className="sub-title">
                      Experience {index + 1}{" "}
                      {formData.experiences.length > 1 && (
                        <button
                          type="button"
                          onClick={() => handleRemoveExperience(index)}
                          className="btn btn-danger btn-sm"
                        >
                          Remove
                        </button>
                      )}
                    </h4>
                    <div className="form-grid">
                      <div className="form-group">
                        <label className="form-label">Company Name</label>
                        <input
                          type="text"
                          name="companyName"
                          pattern="[A-Za-z\s]+"
                          value={exp.companyName || ""}
                          onChange={(e) => handleExperienceChange(index, "companyName", e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Job Title</label>
                        <input
                          type="text"
                          name="jobTitle"
                          pattern="[A-Za-z\s]+"
                          value={exp.jobTitle || ""}
                          onChange={(e) => handleExperienceChange(index, "jobTitle", e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">From Date</label>
                        <input
                          type="date"
                          name="fromDate"
                          value={exp.fromDate ? new Date(exp.fromDate).toISOString().split("T")[0] : ""}
                          onChange={(e) => handleExperienceChange(index, "fromDate", e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">To Date</label>
                        <input
                          type="date"
                          name="toDate"
                          value={exp.toDate ? new Date(exp.toDate).toISOString().split("T")[0] : ""}
                          onChange={(e) => handleExperienceChange(index, "toDate", e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group full-width">
                        <label className="form-label">Job Description</label>
                        <textarea
                          name="jobDescription"
                          rows="3"
                          value={exp.jobDescription || ""}
                          onChange={(e) => handleExperienceChange(index, "jobDescription", e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={handleAddExperience}
                  className="btn btn-secondary mb-3"
                >
                  Add Experience
                </button>
                <div className="form-group">
                  <label htmlFor="currentExperience" className="form-label">
                    Current Experience (in years)
                  </label>
                  <input
                    type="text"
                    id="currentExperience"
                    name="currentExperience"
                    value={formData.currentExperience}
                    maxLength={2}
                    onChange={handleInputChange}
                    placeholder="Enter Current Experience"
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="totalExperience" className="form-label">
                    Total Experience (in years)
                  </label>
                  <input
                    type="text"
                    id="totalExperience"
                    maxLength={2}
                    name="totalExperience"
                    value={formData.totalExperience}
                    onChange={handleInputChange}
                    placeholder="Enter Total Experience"
                    className="form-control"
                  />
                </div>
              </div>
            </section>

            {/* Education Details Section */}
            <section className="form-section">
              <h3 className="section-title">Education Details</h3>
              <div className="form-grid">
                {formData.educations.map((edu, index) => (
                  <div key={index} className="education-block">
                    <h4 className="sub-title">
                      Education {index + 1}{" "}
                      {formData.educations.length > 1 && (
                        <button
                          type="button"
                          onClick={() => handleRemoveEducation(index)}
                          className="btn btn-danger btn-sm"
                        >
                          Remove
                        </button>
                      )}
                    </h4>
                    <div className="form-grid">
                      <div className="form-group">
                        <label className="form-label">Institute Name</label>
                        <input
                          type="text"
                          name="instituteName"
                          value={edu.instituteName || ""}
                          pattern="[A-Za-z\s]+"
                          onChange={(e) => handleEducationChange(index, "instituteName", e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Degree/Diploma</label>
                        <input
                          type="text"
                          name="degreeDiploma"
                          pattern="[A-Za-z0-9. ]+"
                          value={edu.degreeDiploma || ""}
                          onChange={(e) => handleEducationChange(index, "degreeDiploma", e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Specialization</label>
                        <input
                          type="text"
                          name="specialization"
                          pattern="[A-Za-z\s]+"
                          value={edu.specialization || ""}
                          onChange={(e) => handleEducationChange(index, "specialization", e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Date of Completion</label>
                        <input
                          type="date"
                          name="dateOfCompletion"
                          value={edu.dateOfCompletion ? new Date(edu.dateOfCompletion).toISOString().split("T")[0] : ""}
                          onChange={(e) => handleEducationChange(index, "dateOfCompletion", e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={handleAddEducation}
                  className="btn btn-secondary mb-3"
                >
                  Add Education
                </button>
              </div>
            </section>

            {/* Dependent Details Section */}
            <section className="form-section">
              <h3 className="section-title">Dependent Details</h3>
              <div className="form-grid">
                {formData.dependents.map((dep, index) => (
                  <div key={index} className="dependent-block">
                    <h4 className="sub-title">
                      Dependent {index + 1}{" "}
                      {formData.dependents.length > 1 && (
                        <button
                          type="button"
                          onClick={() => handleRemoveDependent(index)}
                          className="btn btn-danger btn-sm"
                        >
                          Remove
                        </button>
                      )}
                    </h4>
                    <div className="form-grid">
                      <div className="form-group">
                        <label className="form-label">Name of Dependent</label>
                        <input
                          type="text"
                          name="name"
                          pattern="[A-Za-z\s]+"
                          value={dep.name || ""}
                          onChange={(e) => handleDependentChange(index, "name", e.target.value)}
                          className="form-control"
                          placeholder="Enter Dependent's Name"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Relationship</label>
                        <select
                          name="relationship"
                          className="form-control"
                          value={dep.relationship || ""}
                          onChange={(e) => handleDependentChange(index, "relationship", e.target.value)}
                        >
                          <option value="">Select Relationship</option>
                          <option value="father">Father</option>
                          <option value="mother">Mother</option>
                          <option value="guardian">Guardian</option>
                          <option value="siblings">Siblings</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label className="form-label">Dependent's Date of Birth</label>
                        <input
                          type="date"
                          name="dateOfBirth"
                          value={dep.dateOfBirth ? new Date(dep.dateOfBirth).toISOString().split("T")[0] : ""}
                          onChange={(e) => handleDependentChange(index, "dateOfBirth", e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Dependent's Mobile Number</label>
                        <input
                          type="tel"
                          name="MobileNumber"
                          pattern="\d{10}"
                          maxLength="10"
                          value={dep.MobileNumber || ""}
                          onChange={(e) => handleDependentChange(index, "MobileNumber", e.target.value)}
                          className="form-control"
                          placeholder="Enter Dependent's Mobile Number"
                        />
                      </div>
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={handleAddDependent}
                  className="btn btn-secondary mb-3"
                >
                  Add Dependent
                </button>
              </div>
            </section>
          </div>
        </form>
      </div>
    </>
  );
};

export default EmployeeForm;
